import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'
import { StatuspageImpact } from '../../types'

type Props = {
	impact: StatuspageImpact | undefined
}

export const Wrapper = styled.div<Props>`
	color: ${({ impact }) => {
		switch (impact) {
			case StatuspageImpact.None:
				return helpers.color.text
			case StatuspageImpact.Minor:
				return helpers.color.status.minor
			case StatuspageImpact.Major:
				return helpers.color.status.major
			case StatuspageImpact.Critical:
				return helpers.color.status.critical
			default:
				return helpers.color.text
		}
	}}
`
